var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('space-page',{attrs:{"spaceId":_vm.spaceId,"teamId":_vm.id,"teamName":_vm.name,"isPullListOnSetup":true}})}
var staticRenderFns = []

export { render, staticRenderFns }